import { FC } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { TableContainer, Spinner, ScreenOverlay, withRouter } from "../../../../components/Common";
import usePagination from "../../../../common/hooks/pagination";
import { toastError } from "../../../../helpers/toast-helper";
import { getResponseData } from "../../../../helpers/response-helper";
import { useQuotesListByRole } from "./helper";
import { useNavigate } from "react-router-dom";

import { GET_COLUMNS } from "../../config";

interface Props {
    isAdmin: boolean;
    userId: string | number;
}

const QuoteList: FC<Props> = ({ isAdmin, userId }) => {
    const {
        pagination,
        setPagination,

        sorting,
        setSorting,

        globalFilter,
        setGlobalFilter,

        params,

        getPageCount,
    } = usePagination();

    const navigate = useNavigate();

    const { data: quoteList, isLoading } = useQuotesListByRole(isAdmin)({
        ...params,
        userId,
    }, {
        onError: () => {
            toastError("Cannot fetch quotes");
        }
    });

    const { data, meta } = getResponseData(quoteList);

    const pageCount = getPageCount(meta);

    return (
        <Row>
            <Col lg="12">
                <Card>
                    <CardBody>
                        <TableContainer
                            columns={GET_COLUMNS}
                            data={data || []}
                            isGlobalFilter={true}
                            isPagination={true}
                            SearchPlaceholder="Search..."
                            isCustomPageSize={true}
                            isAddButton={false}
                            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                            theadClass="table-light"
                            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                            pagination="pagination"

                            manualPagination
                            paginationState={pagination}
                            onPaginationChange={setPagination}
                            pageCount={pageCount}

                            manualSorting
                            sortingState={sorting}
                            onSortingChange={setSorting}

                            manualGlobalFilter={true}
                            globalFilterState={globalFilter}
                            onGlobalFilterChange={setGlobalFilter}

                            onRowClick={(rowData) => {
                                navigate(`/quotes/${rowData.id}`);
                            }}
                        />
                    </CardBody>
                </Card>
            </Col>
            {isLoading && (
                <>
                    <ScreenOverlay/>
                    <Spinner/>
                </>
            )}
        </Row>
    );
};

export default withRouter(QuoteList);
